import { useState, useEffect } from "react";
import { getViteImage } from '../../utils/utils';
import ImageUploadPopup from "./image_upload";
import TransactionHistory from "./transaction_history";
import MyWinnings from "./my_winnings";
import AccountSettings from "./account_setting";
import GamerHandleChange from "./gamerhandle_change";
import Heading_IMg from "../../assets/img/heading3.jpg";

const getAuthState = () => {
    const token = localStorage.getItem("token");
    const rawUser = localStorage.getItem("user");
    let user = null;

    if (rawUser) {
        try {
            user = JSON.parse(rawUser);
        } catch {
            user = null;
        }
    }

    return { isLoggedIn: Boolean(token), user };
};

export default function MyAccount() {

    const [authState, setAuthState] = useState(getAuthState);
    const user = authState.user || {};
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [avatar, setAvatar] = useState(user?.img_url ? user?.img_url : getViteImage(`profile_avatar/${user?.profile_pic || 0}.avif`) || getViteImage("profile_avatar/0.avif"));
    const [activeTab, setActiveTab] = useState("account-setting");
    const subnavItems = [
        { key: "account-setting", label: "Account Settings", iconClass: "fa-solid fa-user-pen" },
        { key: "gamer-handle", label: "Gamer Handles", iconClass: "icon-game-controller" },
        { key: "my-winnings", label: "My Winnings", iconClass: "ic icon-trophy" },
        { key: "transaction-history", label: "Transaction History", iconClass: "ico_wallet" },
        // { key: "friends", label: "Friends", iconClass: "icon-user-following" },
    ];
    useEffect(() => {
        document.title = "Profile - CGES.CLUB";
        const syncAuthState = () => {
            setAuthState(getAuthState());
        };

        syncAuthState();
        window.addEventListener("auth:updated", syncAuthState);
        window.addEventListener("storage", syncAuthState);

        return () => {
            window.removeEventListener("auth:updated", syncAuthState);
            window.removeEventListener("storage", syncAuthState);
        };
    }, []);

    useEffect(() => {
        setAvatar(user?.img_url ? user?.img_url : getViteImage(`profile_avatar/${user?.profile_pic || 0}.avif`) || getViteImage("profile_avatar/0.avif"));
    }, [user?.img_url, user?.profile_pic]);

    const openLoginModal = (e) => {
        if (e) e.preventDefault();
        if (window.UIkit && typeof window.UIkit.modal === "function") {
            window.UIkit.modal("#modal-login", { container: false }).show();
            return;
        }
        window.location.href = "/";
    };

    if (!authState.isLoggedIn) {
        return (
            <>
                <div className="container pd-top-120 pd-bottom-90">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="creator-brochure-hero text-center">
                                <h2 className="title move-line-3d mb-2">My Profile</h2>
                                <p className="creator-brochure-subtitle">
                                    Login to view account settings, gamer handles, winnings, and transaction history.
                                </p>
                                <button className="btn btn-base creator-brochure-cta" onClick={openLoginModal}>
                                    Login To Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <style>{`
                    .creator-brochure-hero {
                        background: radial-gradient(circle at top right, rgba(255, 129, 14, 0.26), transparent 42%), #121212;
                        border: 1px solid #3a3a3a;
                        border-radius: 14px;
                        padding: 26px 20px;
                    }
                    .creator-brochure-subtitle {
                        max-width: 720px;
                        margin: 0 auto 14px;
                        color: #e4e4e4;
                    }
                    .creator-brochure-cta {
                        border: 1px solid #ff810e;
                        background: #161616;
                        color: #fff;
                        min-width: 220px;
                    }
                    @media (max-width: 767px) {
                        .creator-brochure-hero {
                            padding: 20px 14px;
                        }
                        .creator-brochure-cta {
                            width: 100%;
                            min-width: 0;
                        }
                    }
                `}</style>
            </>
        );
    }

    return (
        <>



            <div class="uk-grid" data-uk-grid="">
                <div class="uk-width-1-1@l uk-width-3-4@m uk-first-column">
                    <div class="uk-grid  uk-child-width-2-2@l uk-child-width-2-2@m uk-child-width-1-1@s">
                        <section class="b-post b-post-full b-post-single clearfix">
                            <div class="uk-page-heading uk-page-heading-style-a uk-height-medium uk-height-max-medium uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-background-cover uk-light" data-src="assets/img/heading3.jpg" uk-img="" uk-parallax="bgy: -20" style={{
                                backgroundImage: `url(${Heading_IMg})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "1171px 782px",
                                backgroundPositionY: "calc(-221.05px)"
                            }}>
                                <div class="fl-hd-cover fl-hd-cover-02">
                                    <span class="decore-lt"></span>
                                    <span class="decore-lb"></span>
                                    <span class="decore-rt"></span>
                                    <span class="decore-rb"></span>
                                </div>
                                <div class="fl-hd-avatar">
                                    <a href="#" class="item-avatar pe-none">
                                        <img class="avatar" width="100" height="100" alt="Profile Photo" src={avatar} />
                                    </a>

                                    <div className="camera-icon" onClick={() => setIsPopupOpen(true)}>
                                        <i className="fa fa-camera" style={{ color: "#ff810e" }}></i>
                                    </div>
                                    {isPopupOpen && (
                                        <ImageUploadPopup
                                            onClose={() => setIsPopupOpen(false)}
                                            onAvatarSelect={(newAvatar) => {
                                                if (typeof newAvatar === "number") {
                                                    setAvatar(getViteImage(`profile_avatar/${newAvatar}.avif`));
                                                } else if (typeof newAvatar === "string" && newAvatar.trim()) {
                                                    setAvatar(`${newAvatar}`);
                                                }
                                                setIsPopupOpen(false);
                                            }}
                            />
                                    )}
                                </div>
                                <h6 class="uk-page-heading-h">{user?.name}</h6>
                                <p class="uk-heading-text z-0">Joined on {formatDate(new Date(user?.joined_on))}</p>
                            </div>

                            <div class="fl-subnav">
                                <ul class="uk-subnav uk-subnav-pill" uk-margin="" style={{ background: "transparent", margin: "0px 0px 0px 0px" }}>
                                    {subnavItems.map((item, index) => (
                                        <li
                                            key={item.key}
                                            class={`${activeTab === item.key ? "uk-active" : ""} ${index === 0 ? "uk-first-column" : ""}`.trim()}
                                        >
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setActiveTab(item.key);
                                                }}
                                                style={activeTab === item.key ? { color: "#fff", backgroundColor: "transparent" } : { backgroundColor: "transparent" }}
                                            >
                                                <i class={item.iconClass}></i>
                                                {item.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>


                            <div class="entry-main">
                                <div class="entry-content">
                                    {activeTab === "gamer-handle" ? <GamerHandleChange /> : activeTab === "transaction-history" ?
                                        <TransactionHistory /> : activeTab === "my-winnings" ? <MyWinnings /> : activeTab === "account-setting" ? <AccountSettings /> : null
                                    }
                                </div>

                            </div>
                        </section>



                    </div>


                </div>

            </div>

        </>
    )
}
function formatDate(date) {
    const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits
    const month = date.toLocaleString('en-US', { month: 'short' }); // Short month name
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
}
